import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { CadastroLoginDialog } from './cadastro.login.dialog'; 
import { emailValidator } from '../../controls/validators/app-validators';
import { Router } from '@angular/router';
import { UsersService } from '../../../../models/usuarios.service';
import { Subscription } from 'rxjs';



@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
    form;
    loginEvent:Subscription;
    mensagem:string='';
     usuario= {email:'',
              password:''}


    constructor(
        private router:Router,
        private fb:FormBuilder,
        private dialog: MatDialog,
        private users:UsersService
    ) {
        users.logout();
        this.loginEvent = this.users.loginChange.subscribe( r=>{
            // logou
            this.router.navigate(['/fechamento']);
        })
        
        this.form = this.fb.group({
            'email': [null, Validators.compose([Validators.required, emailValidator])],
            'password': [null, Validators.compose([Validators.required, Validators.minLength(6)])]
          });

    }


    entrar(){
        this.users.login(this.usuario,true);
    }

    ngOnInit(): void { }
    ngOnDestroy(){
        this.loginEvent.unsubscribe();
    }

    cadastrar(){
        console.log('xxxx')
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = "450px";
        //dialogConfig.minHeight = "550px";
        dialogConfig.data = this.usuario;
    
        this.dialog.open(CadastroLoginDialog, dialogConfig);  
      
      }
          
     

}
